





















import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";

@Component({
  inheritAttrs: false,
})
export default class EspecialidadeAutocomplete extends Vue {
  @PropSync("especialidade", { required: true })
  especialidadeSynced!: EspecialidadeModel | undefined;
  especialidadesSynced: EspecialidadeModel[] = [];

  loadingEspecialidades = false;
  nomeEspecialidade = "";

  // Utilizado para o debounce manual
  timerEspecialidade: any = 0;

  @Watch("especialidadeSynced")
  alterarEspecialidade() {
    if (!!this.especialidadeSynced?.nome) {
      this.nomeEspecialidade = this.especialidadeSynced.nome;
    }
  }

  @Watch("nomeEspecialidade")
  obterEspecialidades(val: string) {
    val = (val || "").trim();

    if (val == "") {
      this.especialidadesSynced = [];
      this.especialidadeSynced = undefined;
      return;
    }

    // se o campo tem menos que 5 caracteres não faz a busca
    if (val.length < 4) return;
    this.loadingEspecialidades = true;

    // Debounce manual - LODASH não funcionou
    clearTimeout(this.timerEspecialidade);
    this.timerEspecialidade = setTimeout(() => {
      cadastroPrestadorService
        .obterEspecialidades(val)
        .then((especialidades: EspecialidadeModel[]) => {
          this.especialidadesSynced = especialidades;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingEspecialidades = false;
        });
    }, 300);
  }

  get autoCompleteAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return attrs;
  }

  get validationAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return {
      rules,
      name
    };
  }
}
